import * as yup from 'yup'
import { GenderType, Step1Data, Step2Data, Step3Data, Step4Data, Moment } from '@hooks'
import { IconName } from '@components'
import { SelectionItem } from '@utils'

const GENDER_VALUES: GenderType[] = ['female', 'male', 'non-binary']

const requiredString = (message: string) => yup.string().required(message)

const selectionItemSchema = yup.object().shape({
  id: yup.string().required(),
  name: yup.string().required(),
  color: yup.string().optional(),
  icon: yup.mixed().optional(),
  photo: yup.string().optional(),
  text1: yup.string().optional(),
  text2: yup.string().optional(),
}) as yup.ObjectSchema<SelectionItem>

const momentSchema = yup.object().shape({
  id: yup.string().required(),
  code: yup.mixed<IconName>().required(),
  nameEn: yup.string().required(),
  nameFr: yup.string().required(),
}) as yup.ObjectSchema<Moment>

export const Step1ValidationSchema: yup.ObjectSchema<Step1Data> = yup.object({
  avatar: yup.string().optional(),
  gender: yup
    .mixed<GenderType>()
    .oneOf(GENDER_VALUES, 'Genre invalide')
    .required('Le genre est requis'),
  firstName: requiredString('Le prénom est requis'),
  lastName: requiredString('Le nom est requis'),
  birthday: requiredString('La date de naissance est requise'),
  residence: selectionItemSchema.required('Le lieu de résidence est requis'),
  origins: yup
    .array()
    .of(selectionItemSchema.required("L'origine est requise"))
    .min(1, "Au moins une origine est requise")
    .required("L'origine est requise"),
  nationalities: yup.array().of(selectionItemSchema.required('La nationalité est requise')).min(1, 'Au moins une nationalité est requise').required('La nationalité est requise'),
  languages: yup.array().of(selectionItemSchema.required('La langue est requise')).min(1, 'Au moins une langue est requise').required('Les langues sont requises'),
  info: yup.string().optional(),
}).required()

export const Step2ValidationSchema: yup.ObjectSchema<Step2Data> = yup
  .object({
    hashtags: yup
      .array()
      .of(yup.string().trim().required('Un hashtag est requis'))
      .min(1, 'Au moins un hashtag est requis')
      .required('Les hashtags sont requis'),
  })
  .required()

export const Step3ValidationSchema: yup.ObjectSchema<Step3Data> = yup
  .object({
    moments: yup
      .array()
      .of(momentSchema.required('Un moment est requis'))
      .min(1, 'Au moins un moment est requis')
      .required('Les moments sont requis'),
  })
  .required()

export const Step4ValidationSchema: yup.ObjectSchema<Step4Data> = yup
  .object({
    contactPreferences: yup
      .array()
      .of(
        yup.object().shape({
          key: yup.string().required('Key is required'),
          value: yup.boolean().required('Value is required'),
          iconName: yup.mixed<IconName>().required('Icon name is required'),
        }),
      )
      .required('Contact preferences are required')
      .min(1, 'At least one contact preference is required'),
  })
  .required()
